import React from "react";

const BusinessReviewPreview = ({ answers }) => {
  const businessName = answers.businessName || "Your Business";
  const imageUrl = answers.imageUrl || "";
  const reviewLink = answers.googleReviewLink || "";

  const handleReviewClick = () => {
    if (reviewLink) {
      window.open(reviewLink, "_blank");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg">
      <div className="max-w-md w-full text-center">
        <div className="mb-6">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={businessName}
              className="w-32 h-32 rounded-full mx-auto object-cover mb-4 shadow-lg"
            />
          ) : (
            <div className="w-32 h-32 rounded-full mx-auto mb-4 bg-gray-200 flex items-center justify-center">
              <span className="text-4xl text-gray-400">
                {businessName.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            {businessName}
          </h1>
          <p className="text-gray-600">Help us grow with a review</p>
        </div>
        <button
          onClick={handleReviewClick}
          disabled={!reviewLink}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-4 px-6 rounded-lg text-lg transition-colors"
        >
          Write a Review
        </button>
        {!reviewLink && (
          <p className="text-sm text-gray-500 mt-4">
            Review link will be generated after you save
          </p>
        )}
      </div>
    </div>
  );
};

export default BusinessReviewPreview;
